import React from "react";
import ReactDOM from "react-dom";
import LandingPage from "./LandingPage/LandingPage";

ReactDOM.render(
  <React.StrictMode>
    <LandingPage />
  </React.StrictMode>,
  document.getElementById("root")
);
